'use client';

import { c as _c } from "react/compiler-runtime";
import './birthday-appeal.scss';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Select } from '@sola/ark-core/molecules/select/select.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { BirthdayAppealAmountOption } from './birthday-appeal.logic.ts';
import { useBirthdayAppeal } from './birthday-appeal.logic.ts';
export interface BirthdayAppealAddProps {
  childName: string;
  amountOptions: BirthdayAppealAmountOption[];
  defaultAmount?: string;
  isBusy?: boolean;
  title?: string;
  className?: string;
  background?: string;
  flush?: boolean;
  onAdd: (amount: string) => void;
  onAmountChange?: (amount: string) => void;
}
export const BirthdayAppealAdd: React.FC<BirthdayAppealAddProps> = t0 => {
  const $ = _c(45);
  const {
    childName,
    amountOptions,
    defaultAmount,
    isBusy: t1,
    title,
    className,
    background,
    flush: t2,
    onAdd,
    onAmountChange
  } = t0;
  const isBusy = t1 === undefined ? false : t1;
  const flush = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["checkout"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation(t3);
  let t4;
  if ($[1] !== amountOptions || $[2] !== defaultAmount || $[3] !== onAdd || $[4] !== onAmountChange) {
    t4 = {
      amountOptions,
      defaultAmount,
      onAdd,
      onAmountChange
    };
    $[1] = amountOptions;
    $[2] = defaultAmount;
    $[3] = onAdd;
    $[4] = onAmountChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    selectedAmount,
    handleAmountChange,
    handleAdd
  } = useBirthdayAppeal(t4);
  let t5;
  if ($[6] !== childName || $[7] !== t || $[8] !== title) {
    t5 = title ?? t("checkout:birthdayAppeal.prompt", {
      name: childName,
      defaultValue: "Add Birthday Gift for {{name}}?"
    });
    $[6] = childName;
    $[7] = t;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const promptTitle = t5;
  let t6;
  if ($[10] !== t) {
    t6 = t("checkout:birthdayAppeal.amountLabel", {
      defaultValue: "Birthday gift amount"
    });
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const amountAriaLabel = t6;
  let t7;
  if ($[12] !== amountOptions) {
    t7 = amountOptions.map(_temp);
    $[12] = amountOptions;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const selectItems = t7;
  const t8 = flush ? "BirthdayAppeal--flush" : "p-comfy-sm";
  let t9;
  if ($[14] !== className || $[15] !== t8) {
    t9 = cn("BirthdayAppeal", t8, className);
    $[14] = className;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== background) {
    t10 = background ? {
      background
    } : undefined;
    $[17] = background;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== promptTitle) {
    t11 = <div className="BirthdayAppeal__prompt label-lg label-moderate">{promptTitle}</div>;
    $[19] = promptTitle;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleAmountChange) {
    t12 = e => handleAmountChange(e.target.value);
    $[21] = handleAmountChange;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== amountAriaLabel || $[24] !== isBusy || $[25] !== selectItems || $[26] !== selectedAmount || $[27] !== t12) {
    t13 = <Select name="birthdayGiftAmount" aria-label={amountAriaLabel} items={selectItems} value={selectedAmount} disabled={isBusy} selectClasses="BirthdayAppeal__select" onChange={t12} />;
    $[23] = amountAriaLabel;
    $[24] = isBusy;
    $[25] = selectItems;
    $[26] = selectedAmount;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("checkout:birthdayAppeal.add", {
      defaultValue: "Add"
    });
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== handleAdd || $[32] !== t14) {
    t15 = <button type="button" className="BirthdayAppeal__add" onClick={handleAdd}>{t14}</button>;
    $[31] = handleAdd;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== isBusy || $[35] !== t15) {
    t16 = <ButtonStyle variant="primary" size="md" isBusy={isBusy}>{t15}</ButtonStyle>;
    $[34] = isBusy;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t16) {
    t17 = <div className="BirthdayAppeal__actions flex items-center gap-snug-xl">{t13}{t16}</div>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t10 || $[41] !== t11 || $[42] !== t17 || $[43] !== t9) {
    t18 = <div className={t9} style={t10}>{t11}{t17}</div>;
    $[40] = t10;
    $[41] = t11;
    $[42] = t17;
    $[43] = t9;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
function _temp(t0) {
  const {
    value,
    label
  } = t0;
  return {
    value,
    text: label ?? value
  };
}